<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Costi </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="salvaConsuntivi"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva Consuntivi</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text class="mt-5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <span style="font-size: 18px">
              <b>
                Importo totale: 
                <span v-if="cod_profilo != 'AMM'">
                € {{
                  consuntivo_totale != null && consuntivo_totale != undefined
                    ? consuntivo_totale.toString().includes(".") ||
                      consuntivo_totale.toString().includes(",")
                      ? (
                          parseFloat(
                            consuntivo_totale.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                        ).split(",")[0] +
                        "," +
                        (
                          parseFloat(
                            consuntivo_totale.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                        )
                          .split(",")[1]
                          .substr(0, 2)
                      : parseFloat(
                          consuntivo_totale.toString().replace(",", ".")
                        )
                          .toString()
                          .replace(".", ",")
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                    : "0,00"
                }}
                </span>
                <span v-else>
                  N/D
                </span>
              </b>
            </span>
          </v-col>
        </v-row>
      </v-container>
      <v-tabs
        v-model="tab_consuntivi"
        align-with-title
        slider-color="transparent"
      >
        <v-tab
          active-class="py-0 my-0 indigo white--text"
          class="py-0 my-0"
          v-for="item in [
            'Personale',
            'Materiale',
            'Extra',
            'Lavoro Esterno',
            'Note',
          ]"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab_consuntivi">
        <!-- Tab del Personale -->
        <v-tab-item>
          <v-card outlined>
            <v-card-text>
              <v-data-table
                :items="consuntivi_personale.filter((e) => e.validita === 1)"
                :headers="headers_personale"
              >
                <template v-slot:top>
                  <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                      Voci di Costo
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickAggiungiSpesa(1)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Voce di Costo</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <!-- Bottone di modifica personale -->
                <template v-slot:[`item.modifica`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickModificaPersonale(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica</span>
                  </v-tooltip>
                </template>

                <!-- Colonna dell'operatore -->
                <template v-slot:[`item.id_operatore`]="{ item }">
                  {{
                    item.id_operatore
                      ? fornitore_lista.filter(
                          (e) => e.id_fornitore == item.id_operatore
                        ).length > 0
                        ? fornitore_lista.filter(
                            (e) => e.id_fornitore == item.id_operatore
                          )[0].ragione_sociale
                        : ""
                      : ""
                  }}
                </template>

                <!-- Colonna del costo orario del personale -->
                <template v-slot:[`item.costo_ora`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.costo_ora != null && item.costo_ora != undefined
                      ? item.costo_ora.toString().includes(".") ||
                        item.costo_ora.toString().includes(",")
                        ? (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.costo_ora.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Colonna delle ore del personale -->
                <template v-slot:[`item.ore`]="{ item }">
                  {{
                    item.ore != null && item.ore != undefined
                      ? item.ore.toString().includes(".") ||
                        item.ore.toString().includes(",")
                        ? (
                            parseFloat(item.ore.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(item.ore.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(item.ore.toString().replace(",", "."))
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                </template>

                <!-- Colonna delle ore cantiere del personale -->
                <template v-slot:[`item.ore_cantiere`]="{ item }">
                  {{
                    item.ore_cantiere != null && item.ore_cantiere != undefined
                      ? item.ore_cantiere.toString().includes(".") ||
                        item.ore_cantiere.toString().includes(",")
                        ? (
                            parseFloat(item.ore_cantiere.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(item.ore_cantiere.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(item.ore_cantiere.toString().replace(",", "."))
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                </template>

                <!-- Bottone di eliminazione personale -->
                <template v-slot:[`item.elimina`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickElimina(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Elimina</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab del Materiale -->
        <v-tab-item>
          <v-card outlined>
            <v-card-text>
              <v-data-table
                :items="consuntivi_materiale.filter((e) => e.validita === 1)"
                :headers="headers_materiale"
              >
                <template v-slot:top>
                  <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                      Voci di Costo
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickAggiungiSpesa(2)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Voce di Costo</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <!-- Bottone di modifica materiale -->
                <template v-slot:[`item.modifica`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickModificaMateriale(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica</span>
                  </v-tooltip>
                </template>

                <!-- Colonna del costo del materiale -->
                <template v-slot:[`item.costo_ora`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.costo_ora != null && item.costo_ora != undefined
                      ? item.costo_ora.toString().includes(".") ||
                        item.costo_ora.toString().includes(",")
                        ? (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.costo_ora.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Colonna dell'importo cantiere del materiale -->
                <template v-slot:[`item.importo_cantiere`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.importo_cantiere != null && item.importo_cantiere != undefined
                      ? item.importo_cantiere.toString().includes(".") ||
                        item.importo_cantiere.toString().includes(",")
                        ? (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.importo_cantiere.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Bottone di eliminazione materiale -->
                <template v-slot:[`item.elimina`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickElimina(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Elimina</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab degli Extra -->
        <v-tab-item>
          <v-card outlined>
            <v-card-text>
              <v-data-table
                :items="consuntivi_extra.filter((e) => e.validita === 1)"
                :headers="headers_extra"
              >
                <template v-slot:top>
                  <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                      Voci di Costo
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickAggiungiSpesa(3)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Voce di Costo</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <!-- Bottone di modifica extra -->
                <template v-slot:[`item.modifica`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickModificaExtra(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica</span>
                  </v-tooltip>
                </template>

                <!-- Colonna del costo degli extra -->
                <template v-slot:[`item.costo_ora`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.costo_ora != null && item.costo_ora != undefined
                      ? item.costo_ora.toString().includes(".") ||
                        item.costo_ora.toString().includes(",")
                        ? (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.costo_ora.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Colonna dell'importo cantiere degli extra -->
                <template v-slot:[`item.importo_cantiere`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.importo_cantiere != null && item.importo_cantiere != undefined
                      ? item.importo_cantiere.toString().includes(".") ||
                        item.importo_cantiere.toString().includes(",")
                        ? (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.importo_cantiere.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Bottone di eliminazione extra -->
                <template v-slot:[`item.elimina`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickElimina(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Elimina</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab del Lavoro Esterno -->
        <v-tab-item>
          <v-card outlined>
            <v-card-text>
              <v-data-table
                :items="consuntivi_esterni.filter((e) => e.validita === 1)"
                :headers="headers_esterni"
              >
                <template v-slot:top>
                  <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                      Voci di Costo
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickAggiungiSpesa(4)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Voce di Costo</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <!-- Colonna delle ore del personale esterno -->
                <template v-slot:[`item.ore`]="{ item }">
                  {{
                    item.ore != null && item.ore != undefined
                      ? item.ore.toString().includes(".") ||
                        item.ore.toString().includes(",")
                        ? (
                            parseFloat(item.ore.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(item.ore.toString().replace(",", "."))
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(item.ore.toString().replace(",", "."))
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                </template>

                <!-- Bottone di modifica Esterno -->
                <template v-slot:[`item.modifica`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickModificaEsterno(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica</span>
                  </v-tooltip>
                </template>

                <!-- Colonna del costo orario degli esterni -->
                <template v-slot:[`item.costo_ora`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.costo_ora != null && item.costo_ora != undefined
                      ? item.costo_ora.toString().includes(".") ||
                        item.costo_ora.toString().includes(",")
                        ? (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.costo_ora.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Colonna dell'importo cantiere degli esterni -->
                <template v-slot:[`item.importo_cantiere`]="{ item }">
                  <span v-if="cod_profilo != 'AMM'">
                  {{
                    item.importo_cantiere != null && item.importo_cantiere != undefined
                      ? item.importo_cantiere.toString().includes(".") ||
                        item.importo_cantiere.toString().includes(",")
                        ? (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              item.importo_cantiere.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            item.importo_cantiere.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </template>

                <!-- Bottone di elimina esterno -->
                <template v-slot:[`item.elimina`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="clickElimina(item)"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Elimina</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab delle note -->
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-textarea outlined v-model="note"> </v-textarea>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <!-- Dialog di aggiunta del personale -->
    <v-dialog v-model="dialog_dettaglio_personale">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Spese Personale
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaPersonale" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_dettaglio_personale = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col class="mx-0" cols="3">
              <v-autocomplete
                @change="associaDesTipo"
                :items="items_tipi"
                item-text="des"
                item-value="id_tabella"
                label="Tipo Attività"
                v-model="spesa_sel.id_tipo"
              >
                <template v-slot:append>
                  <v-btn
                    @click="
                      spesa_sel.id_tipo = null;
                      spesa_sel.des_tipo = '';
                      spesa_sel.costo_ora = 0;
                    "
                    icon
                  >
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="mx-0" cols="2">
              <v-autocomplete
                item-text="ragione_sociale"
                item-value="id_fornitore"
                label="Operatore"
                :items="fornitore_lista"
                style="max-width: 250px"
                v-model="spesa_sel.id_operatore"
              >
                <template v-slot:append>
                  <v-icon
                    @click="spesa_sel.id_operatore = null"
                    color="error"
                    v-if="spesa_sel.id_operatore != null"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="mx-0" cols="3">
              <v-text-field
                label="Note"
                v-model="spesa_sel.note"
              ></v-text-field>
            </v-col>
            <v-col class="mx-0" cols="1">
              <v-text-field
                label="Ore Lavorate"
                step="0.5"
                type="number"
                v-model="spesa_sel.ore"
              ></v-text-field>
            </v-col>
            <v-col class="mx-0" cols="1">
              <v-text-field
                label="Ore Cantiere"
                step="0.5"
                type="number"
                v-model="spesa_sel.ore_cantiere"
              ></v-text-field>
            </v-col>
            <v-col class="mx-0" cols="2">
              <div>
                <span>
                  Costo Orario: 
                  <span v-if="cod_profilo != 'AMM'">
                  € {{
                    spesa_sel.costo_ora != null &&
                    spesa_sel.costo_ora != undefined
                      ? spesa_sel.costo_ora.toString().includes(".") ||
                        spesa_sel.costo_ora.toString().includes(",")
                        ? (
                            parseFloat(
                              spesa_sel.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          ).split(",")[0] +
                          "," +
                          (
                            parseFloat(
                              spesa_sel.costo_ora.toString().replace(",", ".")
                            )
                              .toString()
                              .replace(".", ",")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "00"
                          )
                            .split(",")[1]
                            .substr(0, 2)
                        : parseFloat(
                            spesa_sel.costo_ora.toString().replace(",", ".")
                          )
                            .toString()
                            .replace(".", ",")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                      : "0,00"
                  }}
                  </span>
                  <span v-else>
                    N/D
                  </span>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta del materiale -->
    <v-dialog v-model="dialog_dettaglio_materiale">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Spese Materiale
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaMateriale" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_dettaglio_materiale = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  label="Descrizione"
                  v-model="spesa_sel.des"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo Totale"
                  v-model="spesa_sel.costo_ora"
                  :decimali_fissi="true"
                  :key="input_materiale_key"
                  :numero_iniziale="spesa_sel.costo_ora"
                  ref="input_materiale"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo Cantiere"
                  v-model="spesa_sel.importo_cantiere"
                  :decimali_fissi="true"
                  :key="input_materiale_key"
                  :numero_iniziale="spesa_sel.importo_cantiere"
                  ref="input_materiale_cantiere"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta degli extra -->
    <v-dialog v-model="dialog_dettaglio_extra">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Spese Extra
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaExtra" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_dettaglio_extra = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  label="Descrizione"
                  v-model="spesa_sel.des"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo Totale"
                  v-model="spesa_sel.costo_ora"
                  :decimali_fissi="true"
                  :key="input_extra_key"
                  :numero_iniziale="spesa_sel.costo_ora"
                  ref="input_extra"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo Cantiere"
                  v-model="spesa_sel.importo_cantiere"
                  :decimali_fissi="true"
                  :key="input_extra_key"
                  :numero_iniziale="spesa_sel.importo_cantiere"
                  ref="input_extra_cantiere"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta degli esterni -->
    <v-dialog v-model="dialog_dettaglio_esterni">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Spese Esterni
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaEsterno" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_dettaglio_esterni = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  label="Descrizione"
                  v-model="spesa_sel.des"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo"
                  v-model="spesa_sel.costo_ora"
                  :decimali_fissi="true"
                  :key="input_esterno_key"
                  :numero_iniziale="spesa_sel.costo_ora"
                  ref="input_esterni"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
              <v-col cols="3">
                <InputSeparatore2
                  label="Importo Cantiere"
                  v-model="spesa_sel.importo_cantiere"
                  :decimali_fissi="true"
                  :key="input_esterno_key"
                  :numero_iniziale="spesa_sel.importo_cantiere"
                  ref="input_esterni_cantiere"
                  v-if="cod_profilo != 'AMM'"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import InputSeparatore2 from "@/components/TOOLS/InputSeparatore2.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Spesa {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "costo_ora", default_val: 0 },
      { nome: "costo_totale", default_val: 0 },
      { nome: "des", default_val: "" },
      { nome: "des_tipo", default_val: "" },
      { nome: "id_consuntivo", default_val: -1 },
      { nome: "id_intervento", default_val: null },
      { nome: "id_operatore", default_val: null },
      { nome: "id_tipo", default_val: null },
      { nome: "id_tipo_spesa", default_val: null },
      { nome: "id_voce_costo", default_val: -1 },
      { nome: "importo_cantiere", default_val: 0 },
      { nome: "note", default_val: "" },
      { nome: "ore", default_val: 0 },
      { nome: "ore_cantiere", default_val: 0 },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "ConsuntiviDG",
  components: { InputSeparatore2, SnackbarQV },
  props: {
    fornitore_lista: {
      type: Array,
      default: () => [],
    },
    intervento_sel: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_profilo: "",
      fornitore_sel: null,
      id_consuntivo: null,
      note: "",
      spesa_sel: new Spesa(),
      valore_costo_assistenza: null,
      valore_costo_lavoro: null,
      valore_costo_trasferta: null,

      // Modal
      dialog_dettaglio_esterni: false,
      dialog_dettaglio_extra: false,
      dialog_dettaglio_materiale: false,
      dialog_dettaglio_personale: false,
      input_materiale_key: 0,
      input_esterno_key: 0,
      input_extra_key: 0,

      // Array
      consuntivi_esterni: new Array(),
      consuntivi_extra: new Array(),
      consuntivi_materiale: new Array(),
      consuntivi_personale: new Array(),
      headers_esterni: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Importo (€)",
          value: "costo_ora",
          sortable: false,
        },
        {
          text: "Importo Cantiere (€)",
          value: "importo_cantiere",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_extra: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Importo (€)",
          value: "costo_ora",
          sortable: false,
        },
        {
          text: "Importo Cantiere (€)",
          value: "importo_cantiere",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_materiale: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Importo (€)",
          value: "costo_ora",
          sortable: false,
        },
        {
          text: "Importo Cantiere (€)",
          value: "importo_cantiere",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_personale: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "des_tipo",
          sortable: false,
        },
        {
          text: "Operatore",
          value: "id_operatore",
          sortable: false,
        },
        {
          text: "Note",
          value: "note",
          sortable: false,
        },
        {
          text: "Costo Orario (€)",
          value: "costo_ora",
          sortable: false,
        },
        {
          text: "Ore",
          value: "ore",
          sortable: false,
        },
        {
          text: "Ore Cantiere",
          value: "ore_cantiere",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      items_personale: new Array(),
      items_tipi: new Array(),
      tab_consuntivi: new Array(),
      voci_di_costo_ori: new Array(),
    };
  },
  computed: {
    consuntivo_totale() {
      // Imposto un contatore dei costi
      let somma = 0;

      // Sommo tutti i costi totali che trovo nelle tabelle
      this.consuntivi_personale.forEach((e) => {
        if (e.validita === 1) {
          somma += e.costo_totale != null ? e.costo_totale : 0;
        }
      });
      this.consuntivi_materiale.forEach((e) => {
        if (e.validita === 1) {
          somma += e.costo_totale != null ? e.costo_totale : 0;
        }
      });
      this.consuntivi_extra.forEach((e) => {
        if (e.validita === 1) {
          somma += e.costo_totale != null ? e.costo_totale : 0;
        }
      });
      this.consuntivi_esterni.forEach((e) => {
        if (e.validita === 1) {
          somma += e.costo_totale != null ? e.costo_totale : 0;
        }
      });

      // Ritorno il contatore aggiornato dopo le sommatorie
      return somma;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        this.getConsuntiviDG();
        this.getTabelle();
        this.tab_consuntivi = [];
      },
    },
  },
  methods: {
    associaDesTipo() {
      this.items_tipi.forEach((t) => {
        if (t.id_tabella === this.spesa_sel.id_tipo) {
          this.spesa_sel.des_tipo = t.des;
          this.spesa_sel.costo_ora = t.val_dbl;
        }
      });
    },
    clickAggiungiSpesa(arg) {
      this.spesa_sel = new Spesa();
      this.spesa_sel.id_tipo_spesa = arg;
      this.spesa_sel.id_consuntivo = this.id_consuntivo;
      this.spesa_sel.id_intervento = this.intervento_sel.id_intervento;

      if (arg === 4 || arg === 3 || arg === 2) {
        this.spesa_sel.ore = 1;
      }

      if (arg === 1) {
        this.dialog_dettaglio_personale = true;
      } else if (arg === 2) {
        this.dialog_dettaglio_materiale = true;
        this.$nextTick(() => {
          this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;
          this.$refs.input_materiale_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
          this.input_materiale_key = this.input_materiale_key === 0 ? 1 : 0;
        });
      } else if (arg === 3) {
        this.dialog_dettaglio_extra = true;
        this.$nextTick(() => {
          this.$refs.input_extra.numero_iniziale = this.spesa_sel.costo_ora;
          this.$refs.input_extra_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
          this.input_extra_key = this.input_extra_key === 0 ? 1 : 0;
        });
      } else if (arg === 4) {
        this.dialog_dettaglio_esterni = true;
        this.$nextTick(() => {
          this.$refs.input_esterni.numero_iniziale = this.spesa_sel.costo_ora;
          this.$refs.input_esterni_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
          this.input_esterno_key = this.input_esterno_key === 0 ? 1 : 0;
        });
      }
    },
    clickElimina(arg) {
      arg.validita = 0;
    },
    clickModificaEsterno(arg) {
      this.spesa_sel = new Spesa(arg);
      this.dialog_dettaglio_esterni = true;
      this.$nextTick(() => {
        this.$refs.input_esterni.numero_iniziale = this.spesa_sel.costo_ora;
        this.$refs.input_esterni_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
      });
    },
    clickModificaExtra(arg) {
      this.spesa_sel = new Spesa(arg);
      this.dialog_dettaglio_extra = true;
      this.$nextTick(() => {
        this.$refs.input_extra.numero_iniziale = this.spesa_sel.costo_ora;
        this.$refs.input_extra_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
      });
    },
    clickModificaMateriale(arg) {
      this.spesa_sel = new Spesa(arg);
      this.dialog_dettaglio_materiale = true;
      this.$nextTick(() => {
        this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;
        this.$refs.input_materiale_cantiere.numero_iniziale = this.spesa_sel.importo_cantiere;
      });
    },
    clickModificaPersonale(arg) {
      this.spesa_sel = new Spesa(arg);
      this.dialog_dettaglio_personale = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    getConsuntiviDG() {
      /* Faccio una prima chiamata per avere i dettagli
       * dell'intervento con cui prendermi gli altri dati. */
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getinterventodettaglio",
          token: localStorage.user_token,
          id_intervento: this.intervento_sel.id_intervento,
          id_regola: this.intervento_sel.id_regola,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Se la response è ok, eseguo in coda la seconda
             * chiamata per avere i dettagli del consuntivo. */
            this.id_consuntivo = res.data.result.consuntivo[0].id_consuntivo;
            this.fornitore_sel = res.data.result.consuntivo[0].id_fornitore;

            const request1 = {
              controller: "Manutenzione",
              method: "POST",
              richiesta: {
                action: "getconsuntividg",
                token: localStorage.user_token,
                id_consuntivo: this.intervento_sel.id_consuntivo,
              },
            };

            this.$store
              .dispatch("api", request1)
              .then((res1) => {
                if (res1.status === 200) {
                  // Smisto le voci di costo
                  if (res1.data.result.voci_di_costo) {
                    this.consuntivi_personale = new Array();
                    this.consuntivi_materiale = new Array();
                    this.consuntivi_esterni = new Array();
                    this.consuntivi_extra = new Array();

                    this.voci_di_costo_ori = new Array();

                    res1.data.result.voci_di_costo.forEach((v) => {
                      const voce_tmp = new Spesa(v);
                      voce_tmp.costo_totale =
                        new Number(voce_tmp.costo_ora) *
                        new Number(voce_tmp.ore);

                      voce_tmp.importo_cantiere = new Number(voce_tmp.importo_cantiere).toString();

                      if (voce_tmp.id_tipo_spesa === 1) {
                        voce_tmp.des_tipo_spesa = "Personale";
                      } else if (voce_tmp.id_tipo_spesa === 2) {
                        voce_tmp.des_tipo_spesa = "Materiale";
                      } else if (voce_tmp.id_tipo_spesa === 3) {
                        voce_tmp.des_tipo_spesa = "Extra";
                      } else if (voce_tmp.id_tipo_spesa === 4) {
                        voce_tmp.des_tipo_spesa = "Lavoro Esterno";
                      }

                      this.voci_di_costo_ori.push(voce_tmp);
                    });

                    res1.data.result.voci_di_costo.forEach((v) => {
                      if (v.id_tipo_spesa === 1) {
                        const obj_tmp = new Spesa(v);
                        obj_tmp.ore = parseFloat(v.ore);
                        obj_tmp.costo_ora = parseFloat(v.costo_ora);
                        obj_tmp.costo_totale = obj_tmp.costo_ora * obj_tmp.ore;
                        this.consuntivi_personale.push(
                          Object.assign({}, obj_tmp)
                        );
                      } else if (v.id_tipo_spesa === 2) {
                        const obj_tmp = new Spesa(v);
                        obj_tmp.ore = parseFloat(v.ore);
                        obj_tmp.costo_ora = parseFloat(v.costo_ora);
                        obj_tmp.costo_totale = obj_tmp.costo_ora * obj_tmp.ore;
                        this.consuntivi_materiale.push(
                          Object.assign({}, obj_tmp)
                        );
                      } else if (v.id_tipo_spesa === 3) {
                        const obj_tmp = new Spesa(v);
                        obj_tmp.ore = parseFloat(v.ore);
                        obj_tmp.costo_ora = parseFloat(v.costo_ora);
                        obj_tmp.costo_totale = obj_tmp.costo_ora * obj_tmp.ore;
                        this.consuntivi_extra.push(Object.assign({}, obj_tmp));
                      } else if (v.id_tipo_spesa === 4) {
                        const obj_tmp = new Spesa(v);
                        obj_tmp.ore = parseFloat(v.ore);
                        obj_tmp.costo_ora = parseFloat(v.costo_ora);
                        obj_tmp.costo_totale = obj_tmp.costo_ora * obj_tmp.ore;
                        this.consuntivi_esterni.push(
                          Object.assign({}, obj_tmp)
                        );
                      }
                    });
                  }

                  // Prendo il personale
                  // if (res1.data.result.personale) {
                  //   this.items_personale = Array.from(
                  //     res1.data.result.personale
                  //   );
                  // }

                  // Registro le note
                  if (res1.data.result.consuntivo) {
                    if (res1.data.result.consuntivo.length > 0) {
                      this.note = res1.data.result.consuntivo[0].note;
                    }
                  }
                } else {
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, impossibile caricare i dati."
                  );
                }
              })
              .catch((err1) => {
                if (err1) {
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, impossibile caricare i dati."
                  );
                }
              });
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print("error", `${err}`);
          }
        });
    },
    getTabelle() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "MAN_TIPO_ATTIVITA_DG",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_tipi = new Array();

            res.data.forEach((e) => {
              if (e.cod === "lavoro") {
                this.valore_costo_lavoro = e.val_dbl;
                this.items_tipi.push(Object.assign({}, e));
              } else if (e.cod === "assistenza") {
                this.valore_costo_assistenza = e.val_dbl;
                this.items_tipi.push(Object.assign({}, e));
              } else if (e.cod === "trasferta") {
                this.valore_costo_trasferta = e.val_dbl;
                this.items_tipi.push(Object.assign({}, e));
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });
    },
    salvaEsterno() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel.costo_ora == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare il costo dell'attività."
        );
        return;
      }

      if (this.spesa_sel.costo_ora < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il costo dell'attività non può essere inferiore a 0."
        );
        return;
      }

      this.spesa_sel.costo_totale =
        this.spesa_sel.costo_ora * this.spesa_sel.ore;
      if (this.spesa_sel.id_voce_costo === -1) {
        this.spesa_sel.id_voce_costo = -moment().valueOf();
        this.consuntivi_esterni.push(Object.assign({}, this.spesa_sel));
      } else {
        for (let i = 0; i < this.consuntivi_esterni.length; i++) {
          if (
            this.consuntivi_esterni[i].id_voce_costo ===
            this.spesa_sel.id_voce_costo
          ) {
            this.$set(this.consuntivi_esterni, i, this.spesa_sel);
          }
        }
      }

      /* Forzo ulteriormente il reset del campo,
       * altrimenti rischia di non venire resettato. */
      this.spesa_sel = new Spesa();
      this.$refs.input_esterni.numero_iniziale = this.spesa_sel.costo_ora;
      this.dialog_dettaglio_esterni = false;
    },
    salvaExtra() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel.costo_ora == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare il costo dell'attività."
        );
        return;
      }

      if (this.spesa_sel.costo_ora < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il costo dell'attività non può essere inferiore a 0."
        );
        return;
      }

      this.spesa_sel.costo_totale =
        this.spesa_sel.costo_ora * this.spesa_sel.ore;
      if (this.spesa_sel.id_voce_costo === -1) {
        this.spesa_sel.id_voce_costo = -moment().valueOf();
        this.consuntivi_extra.push(Object.assign({}, this.spesa_sel));
      } else {
        for (let i = 0; i < this.consuntivi_extra.length; i++) {
          if (
            this.consuntivi_extra[i].id_voce_costo ===
            this.spesa_sel.id_voce_costo
          ) {
            this.$set(this.consuntivi_extra, i, this.spesa_sel);
          }
        }
      }
      /* Forzo ulteriormente il reset del campo,
       * altrimenti rischia di non venire resettato. */
      this.spesa_sel = new Spesa();
      this.$refs.input_extra.numero_iniziale = this.spesa_sel.costo_ora;

      this.dialog_dettaglio_extra = false;
    },
    salvaMateriale() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel.costo_ora == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare il costo dell'attività."
        );
        return;
      }

      if (this.spesa_sel.costo_ora < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il costo dell'attività non può essere inferiore a 0."
        );
        return;
      }

      this.spesa_sel.costo_totale =
        this.spesa_sel.costo_ora * this.spesa_sel.ore;
      if (this.spesa_sel.id_voce_costo === -1) {
        this.spesa_sel.id_voce_costo = -moment().valueOf();
        this.consuntivi_materiale.push(Object.assign({}, this.spesa_sel));
      } else {
        for (let i = 0; i < this.consuntivi_materiale.length; i++) {
          if (
            this.consuntivi_materiale[i].id_voce_costo ===
            this.spesa_sel.id_voce_costo
          ) {
            this.$set(this.consuntivi_materiale, i, this.spesa_sel);
          }
        }
      }
      /* Forzo ulteriormente il reset del campo,
       * altrimenti rischia di non venire resettato. */
      this.spesa_sel = new Spesa();
      this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;

      this.dialog_dettaglio_materiale = false;
    },
    salvaPersonale() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel.id_tipo == null) {
        this.$refs.SnackbarQV.print("orange", "Indicare un tipo di attività.");
        return;
      }

      if (this.spesa_sel.ore == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare l'ammontare di ore dedicate all'attività."
        );
        return;
      }

      if (this.spesa_sel.ore < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Le ore dedicate all'attività non possono essere inferiori a 0."
        );
        return;
      }

      this.spesa_sel.costo_totale =
        this.spesa_sel.costo_ora * this.spesa_sel.ore;
      if (this.spesa_sel.id_voce_costo === -1) {
        this.spesa_sel.id_voce_costo = -moment().valueOf();
        this.consuntivi_personale.push(Object.assign({}, this.spesa_sel));
      } else {
        for (let i = 0; i < this.consuntivi_personale.length; i++) {
          if (
            this.consuntivi_personale[i].id_voce_costo ===
            this.spesa_sel.id_voce_costo
          ) {
            this.$set(this.consuntivi_personale, i, this.spesa_sel);
          }
        }
      }
      this.dialog_dettaglio_personale = false;
      this.spesa_sel = new Spesa();
    },
    salvaConsuntivi() {
      // Dichiaro una tabella temporanea in cui inserisco tutti i consuntivi.
      const tabella_tmp = new Array();

      /* Aggiungo i consuntivi all'array temporaneo; se il consuntivo
       * era nuovo ed è subito stato eliminato evito di aggiungerlo.
       * Inoltre faccio in modo che gli identificativi temporanei siano
       * impostati a -1 per tutti gli oggetti nuovi, per convenienza di BE. */
      this.consuntivi_esterni.forEach((c) => {
        if (!(c.id_voce_costo === -1 && c.validita === 0)) {
          const obj_tmp = Object.assign({}, c);
          obj_tmp.des.replaceAll('"', "”");
          obj_tmp.id_voce_costo = c.id_voce_costo < 0 ? -1 : c.id_voce_costo;
          obj_tmp.ore = obj_tmp.ore.toString();
          obj_tmp.costo_ora = obj_tmp.costo_ora.toString();
          tabella_tmp.push(Object.assign({}, obj_tmp));
        }
      });
      this.consuntivi_extra.forEach((c) => {
        if (!(c.id_voce_costo === -1 && c.validita === 0)) {
          const obj_tmp = Object.assign({}, c);
          obj_tmp.des.replaceAll('"', "”");
          obj_tmp.id_voce_costo = c.id_voce_costo < 0 ? -1 : c.id_voce_costo;
          obj_tmp.ore = obj_tmp.ore.toString();
          obj_tmp.costo_ora = obj_tmp.costo_ora.toString();
          tabella_tmp.push(Object.assign({}, obj_tmp));
        }
      });
      this.consuntivi_materiale.forEach((c) => {
        if (!(c.id_voce_costo === -1 && c.validita === 0)) {
          const obj_tmp = Object.assign({}, c);
          obj_tmp.des = obj_tmp.des.replaceAll('"', "”");
          obj_tmp.id_voce_costo = c.id_voce_costo < 0 ? -1 : c.id_voce_costo;
          obj_tmp.ore = obj_tmp.ore.toString();
          obj_tmp.costo_ora = obj_tmp.costo_ora.toString();
          tabella_tmp.push(Object.assign({}, obj_tmp));
        }
      });
      this.consuntivi_personale.forEach((c) => {
        if (!(c.id_voce_costo === -1 && c.validita === 0)) {
          const obj_tmp = Object.assign({}, c);
          obj_tmp.des.replaceAll('"', "”");
          obj_tmp.id_voce_costo = c.id_voce_costo < 0 ? -1 : c.id_voce_costo;
          obj_tmp.ore = obj_tmp.ore.toString();
          obj_tmp.costo_ora = obj_tmp.costo_ora.toString();
          tabella_tmp.push(Object.assign({}, obj_tmp));
        }
      });

      tabella_tmp.forEach((e) => {
        if (e.id_tipo_spesa === 1) {
          e.des_tipo_spesa = "Personale";
        } else if (e.id_tipo_spesa === 2) {
          e.des_tipo_spesa = "Materiale";
        } else if (e.id_tipo_spesa === 3) {
          e.des_tipo_spesa = "Extra";
        } else if (e.id_tipo_spesa === 4) {
          e.des_tipo_spesa = "Lavoro Esterno";
        }
      });

      // Compongo la request
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setconsuntividg",
          token: localStorage.user_token,
          tabella: tabella_tmp,
          tabella_ori: this.voci_di_costo_ori,
          consuntivo: [
            {
              id_consuntivo: this.id_consuntivo,
              note: this.note,
              id_fornitore: this.fornitore_sel,
            },
          ],
        },
      };

      // Eseguo il dispatch al BE
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$emit("salvati_consuntivi");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        });
    },
  },
  created() {},
  mounted() {
    this.cod_profilo = localStorage.cod_profilo;
  },
};
</script>
<style scoped>
</style>